import useIsFeatureEnabled from './useIsFeatureEnabled';

export default function useLobbyBypass(): boolean | undefined {
  return useIsFeatureEnabled('lobbyBypass');
}
